<template>
  <div class="loadboard-bids-tab">
    <template v-if="activeLoadboards.loading">
      <Card
        v-for="loadboard in loadboards"
        :key="`skeleton-${loadboard.id ?? loadboard.source}`"
        class="loadboard-card loadboard-card-skeleton"
      >
        <template #content>
          <div class="loadboard-card-header">
            <Skeleton width="4rem" height="var(--sp-8)" />
            <Skeleton width="40%" height="1rem" />
            <Skeleton
              shape="circle"
              size="var(--sp-8)"
              class="loadboard-card-skeleton-remove"
            />
          </div>
          <div class="loadboard-card-details">
            <Skeleton width="80%" height="1rem" />
            <Skeleton width="80%" height="1rem" />
          </div>
          <Skeleton
            width="60%"
            height="0.875rem"
            class="loadboard-card-skeleton-comments"
          />
        </template>
      </Card>
    </template>
    <LoadboardPostingStatusCard
      v-for="loadboard in loadboards"
      v-else
      :key="loadboard.id ?? loadboard.source"
      :loadboard="loadboard"
      @remove="emit('remove-loadboard', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';

import { Loadable } from '@rygen/rygen-ui/model';

import { Loadboard, LoadboardSource } from '@/model';

import LoadboardPostingStatusCard from '@/components/rateShop/loadboard/LoadboardPostingStatusCard.vue';
import Card from 'primevue/card';
import Skeleton from 'primevue/skeleton';

const props = defineProps({
  activeLoadboards: {
    type: Object as PropType<Loadable<Loadboard[]>>,
    default: () => ({ loading: false }),
  },
});
const { activeLoadboards } = toRefs(props);

const loadboards = computed(() => activeLoadboards.value.data ?? []);

const emit = defineEmits<{
  (event: 'remove-loadboard', source: LoadboardSource): void;
}>();
</script>

<style>
.loadboard-bids-tab {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-4);
  margin-top: var(--sp-6);

  .loadboard-card-skeleton {
    .loadboard-card-skeleton-remove {
      margin-left: auto;
    }

    .loadboard-card-skeleton-comments {
      margin-top: var(--sp-3);
    }
  }
}
</style>
